import api from './api';

export type TopIpItem = {
  ip: string;
  total: number;
  status401: number;
  status429: number;
  status5xx: number;
  firstSeen: number | null;
  lastSeen: number | null;
  topUrls: Array<{ url: string; count: number }>;
};

export type TopIpsResponse = {
  minutes: number;
  limit: number;
  file: string;
  fileSize: number;
  tailBytesRequested: number;
  tailBytesRead: number;
  scannedLines: number;
  matchedLines: number;
  firstLogTs: number | null;
  lastLogTs: number | null;
  items: TopIpItem[];
};

export type BlockedIp = {
  id: number;
  ip: string;
  reason: string | null;
  expiresAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export type BlockedIpsResponse = {
  items: BlockedIp[];
  total: number;
  page: number;
  limit: number;
};

export async function getTopIps(params?: { minutes?: number; limit?: number }) {
  const res = await api.get<TopIpsResponse>('/admin/security/top-ips', { params });
  return res.data;
}

export async function getBlockedIps(params?: { page?: number; limit?: number; ip?: string }) {
  const res = await api.get<BlockedIpsResponse>('/admin/security/blocked-ips', { params });
  return res.data;
}

export async function blockIp(payload: { ip: string; reason?: string; expiresAt?: string }) {
  const res = await api.post<BlockedIp>('/admin/security/blocked-ips', payload);
  return res.data;
}

export async function unblockIp(id: number) {
  const res = await api.post<{ ok: true }>(`/admin/security/blocked-ips/${id}/unblock`);
  return res.data;
}
